import React, { memo } from 'react';
import { Handle, Position, type NodeProps } from 'reactflow';
import { Radio, Signal, Zap } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

const SignalStartNode = ({ data, selected }: NodeProps) => {
    return (
        <div className="relative group">
            <Card
                className={`
                    w-64 border-2 shadow-sm transition-all duration-300
                    ${selected
                        ? 'border-yellow-400 ring-4 ring-yellow-400/20 shadow-xl'
                        : 'border-yellow-200 hover:border-yellow-300 hover:shadow-md bg-yellow-50/50'
                    }
                `}
            >
                {/* Header Strip */}
                <div className={`h-1.5 w-full ${selected ? 'bg-yellow-500' : 'bg-yellow-400'} rounded-t-sm`} />

                <CardContent className="p-3">
                    <div className="flex items-start gap-3">
                        {/* Huge Icon on Left */}
                        <div className={`
                            p-2.5 rounded-xl transition-colors
                            ${selected ? 'bg-yellow-100 text-yellow-600' : 'bg-white text-yellow-500 border border-yellow-100'}
                        `}>
                            <Radio className="h-6 w-6" strokeWidth={1.5} />
                        </div>

                        <div className="flex-1 min-w-0">
                            <h3 className="text-xs font-bold text-gray-900 leading-none mb-1">
                                {data.label || 'Signal Start'}
                            </h3>
                            <p className="text-[10px] text-gray-500 leading-tight truncate font-mono">
                                {data.signalType || 'Type: Any'}
                            </p>

                            {/* status badge */}
                            <div className="mt-2 flex items-center gap-1.5">
                                <span className="relative flex h-2 w-2">
                                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-yellow-400 opacity-75"></span>
                                    <span className="relative inline-flex rounded-full h-2 w-2 bg-yellow-500"></span>
                                </span>
                                <span className="text-[9px] font-medium text-yellow-600 uppercase tracking-wider">Listening</span>
                            </div>
                        </div>
                    </div>
                </CardContent>
            </Card>

            {/* Source Handle Only (Start Node) */}
            <Handle
                type="source"
                position={Position.Right}
                className={`
                    !w-3 !h-3 !bg-yellow-400 !border-2 !border-white
                    transition-all duration-200
                    ${selected ? '!w-4 !h-4 !bg-yellow-500' : ''}
                `}
            />
        </div>
    );
};

export default memo(SignalStartNode);
